import { Link } from "react-router-dom";
import { CityPage, FAQ, CityProduct } from "./CityPage";
import { URLS } from "../../adds/product-links";

const products: CityProduct[] = [
  {
    title: "Elektrische fiets",
    description:
      "Rotterdam kent veel wind en open water. Met een e-bike is zelfs een lange rit tegen de wind prima te doen.",
    url: URLS.ebike,
  },
  {
    title: "Regenjas voor op de fiets",
    description:
      "Kustregen in combinatie met wind maakt een goede regenjas in Rotterdam bijna onmisbaar.",
    url: URLS.raincoat,
  },
  {
    title: "Fietsverlichting",
    description:
      "Veel Rotterdamse bruggen en kades zijn slecht verlicht. Een goede fietslamp helpt om gezien te worden.",
    url: URLS.lights,
  },
];

const faqs: FAQ[] = [
  {
    question: "Waait het hard in Rotterdam?",
    answer:
      "Rotterdam ligt dicht bij de Noordzee en heeft veel open water (Maas, havengebied), waardoor er weinig beschutting is. Dat maakt Rotterdam een van de winderigste grote steden om in te fietsen.",
  },
  {
    question: "Is de Erasmusbrug lastig met de fiets bij wind?",
    answer:
      "De Erasmusbrug staat hoog boven het water en biedt weinig luwte, dus bij harde wind voel je dat flink. Check voor je oversteek even de windvoorspelling zodat je weet wat je tegenkomt.",
  },
  {
    question: "Hoe is het fietsen van Rotterdam naar Delft?",
    answer:
      "De ~15 km rit via de Schie loopt grotendeels door open polderland, dus bij zuidwestenwind kan er flinke zij- of tegenwind staan. Een populaire forenzen- en studentenroute.",
  },
];

export function Rotterdam() {
  return (
    <CityPage
      city="Rotterdam"
      title="Fietsweer Rotterdam | Heb ik tegenwind?"
      description="Bekijk het fietsweer in Rotterdam. Met veel open haven en brede rivieren is de wind hier goed voelbaar. Check of je tegenwind hebt op jouw route."
      path="/fietsweer/rotterdam"
      faqs={faqs}
      products={products}
    >
      <p>
        Rotterdam is een stad van brede rivieren, open haven en flinke
        windhoeken. Maasstad op z'n best, maar voor fietsers ook een plek
        waar de wind je rit serieus kan opstoken. Op de Erasmusbrug, langs de
        kade of op weg naar Hoek van Holland staat bijna altijd wel wat wind.
        Met de fietsweer-tool weet je vooraf waar je aan toe bent.
      </p>

      <h3>Wind in Rotterdam: altijd iets te voelen</h3>
      <p>
        Vanwege de ligging dicht bij de kust krijg je in Rotterdam de volle
        laag bij zuidwesten- en westenwind. De open havens en het water rond
        de Maas zorgen dat er nauwelijks luwte is. Richting Noord en Kralingen
        staat de wind vaak van achter of opzij, maar ga je op de terugweg
        richting het centrum of verder naar Schiedam dan kun je vaak rekenen
        op stevige tegenwind.
      </p>

      <h3>Populaire fietsroutes in Rotterdam</h3>
      <ul>
        <li>
          <strong>Rotterdam Centrum → Kralingse Plas:</strong> een mooi rondje
          met beschutting in het park, maar de heenweg door de stad kan
          stevig tegenwinden.
        </li>
        <li>
          <strong>Rotterdam → Delft:</strong> via de Schie, populair voor
          forenzen en studenten, maar grotendeels in open gebied.
        </li>
        <li>
          <strong>Rotterdam → Hoek van Holland:</strong> lange rit langs de
          Maasmond, bij noordwestenwind een flinke uitdaging.
        </li>
        <li>
          <strong>Rotterdam → Dordrecht:</strong> langs de rivier, vlak
          landschap en weinig beschutting.
        </li>
      </ul>

      <h3>Check de wind voor jouw rit</h3>
      <p>
        Met de <Link to="/">fietsweer-tool</Link> voer je je route in en zie je
        precies welk deel je tegenwind, meewind of zijwind hebt. Handig voor
        het woon-werk, studentenritjes naar Erasmus of een weekendtocht naar
        het strand.
      </p>

      <h3>Meer lezen</h3>
      <ul>
        <li>
          <Link to="/tegenwind-tips">Hoe fiets je effectief tegen de wind in</Link>
        </li>
        <li>
          <Link to="/klimaat-verandering">Wind en klimaatverandering</Link>
        </li>
      </ul>
    </CityPage>
  );
}
